module.exports = __webpack_public_path__ + "img/kd_v2.5154441.png";